import React from "react";
import { Col } from "antd";

export function Help() {
  return <Col style={{ marginTop: "20px" }}>Help</Col>;
}
